import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJustgivingComponent } from './simple-icons-justgiving.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJustgivingComponent ],
    exports:      [ SimpleIconsJustgivingComponent ],
    bootstrap:    []
})
export class SimpleIconsJustgivingModule {}
